<!-- 企业级-盘点记录 -->
<template>
  <div class="mainArea CCasualUser">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <CBreadCrumb></CBreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <div class="searchDiv">
        <div class="flex">
          <div class="mr10">
            <el-input clearable placeholder="请输入操作人姓名" v-model="keyword.user_name" @change="getList(1)" clearable>
            </el-input>
          </div>

          <el-cascader clearable class="mr10" v-model="value" :options="position" :props="{ checkStrictly: true }"
            @change="handleChange">
          </el-cascader>
          <div class="mr10">

            <el-date-picker v-model="time" type="datetimerange" start-placeholder="盘点开始日期" end-placeholder="盘点结束日期"
              format="yyyy-MM-dd HH:mm">
            </el-date-picker>
          </div>
          <el-select class="mr10" v-model="keyword.flag" clearable placeholder="请选择盘点情况">
            <el-option v-for="item in inventoryStatus" :key="item.valueI" :label="item.label" :value="item.valueI">
            </el-option>
          </el-select>
          <div>
            <el-button type="primary" @click="getList(1)">搜索</el-button>
          </div>
        </div>
      </div>
      <!-- 按钮区域 -->
      <div class="btnArea">
        <el-button class="btn" @click="exportCsv()">导出</el-button>
      </div>

      <div class="tableList mt20">
        <el-table :data="dataList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="order_sn" sortable label="盘点单号"></el-table-column>
          <el-table-column prop="user_name" sortable label="操作人"></el-table-column>
          <el-table-column prop="area" sortable label="盘点位置"></el-table-column>
          <el-table-column prop="start_time" sortable label="盘点时间"></el-table-column>
          <el-table-column label="盘点情况">
            <template slot-scope="scope">
              <el-button v-if="scope.row.flag=='1'" type="text">正常</el-button>
              <el-button v-else type="text">异常</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="备注"></el-table-column>
          <el-table-column label="详情">
            <template slot-scope="scope">
              <el-button @click="info(scope.row.id)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paging" v-if="pageCount">
        <el-pagination @current-change="CurrentChange" :current-page.sync="curr" @size-change="CurrentSizeChange"
          :page-sizes="[10,50,100,1000]" :page-size="page" layout="sizes,prev, pager, next, jumper"
          :page-count="pageCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="equipDio" width="50%" class="equipDio">
      <div class="dioCont">
        <el-table :data="detail" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="product_sn" label="档案编号"></el-table-column>
          <el-table-column prop="product_name" label="档案名称"></el-table-column>
          <el-table-column prop="category_name" label="类别"></el-table-column>
          <el-table-column label="结果">
            <template slot-scope="scope">
              <el-button v-if="scope.row.check_status=='0'" type="text">在库</el-button>
              <el-button v-if="scope.row.check_status=='1'" type="text">盘盈</el-button>
              <el-button v-if="scope.row.check_status=='2'" type="text">盘亏</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging" v-if="eq_total>eq_page">
        <el-pagination @current-change="eqCurrentChange" :current-page.sync="eq_curr" :page-size="eq_page"
          layout="prev, pager, next, jumper" :total="eq_total">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
      <div class="statusCont">
        <div>当前状态为 <b v-if="statusInfo.status=='1'">正常</b><b v-else>禁用</b></div>
        <div>是否将状态改为 <b v-if="statusInfo.status=='0'">正常</b><b v-else>禁用</b>？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>取 消</el-button>
        <el-button type="primary"><template v-if="statusInfo.status=='1'">禁用</template><template v-else>正常</template>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CBreadCrumb from "../Layout/CBreadCrumb.vue"
import { showToast } from "../../../../static/js/utility/utility.js"
import { lvApi } from "../../../../static/js/api.js"

var config = require('../../../../static/js/config.js')

export default {
  name: 'CCasualUser',
  components: {
    CBreadCrumb
  },
  data () {
    return {
      dataList: [],
      detail: [],
      options: [{
        valueO: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }],
      //盘点情况
      inventoryStatus: [{
        valueI: '1',
        label: '正常'
      }, {
        valueI: '2',
        label: '异常'
      }],
      valueO: '',
      valueI: '',
      value1: '',

      time: [],

      keyword: {
        user_name: '',//姓名
        flag: '',
        start_time: '',
        end_time: '',
        area: 0,
        col: 0,
        knot: 0
      },
      casualData: [],//临时用户列表数据
      tableLoading: false,
      value: [],
      position: [],

      //分页
      curr: 1,//当前页
      page: 10,//显示个数
      pageCount: 0,//总数据

      tabNum: '1',//tab默认选中

      equipDio: false,//关联设备弹窗
      equipData: [],//关联的设备列表
      //详情分页
      eq_id: 0, //详情id
      eq_curr: 1,//当前页
      eq_page: 10,//显示个数
      eq_total: 0,//总数据

      statusDio: false,//状态弹窗
      statusInfo: {
        user_id: '',
        status: '',
      },
    }
  },
  mounted () {
  },
  created: async function () {
    //获取位置信息
    this.getPosition();
    //获取盘点数据列表
    this.getList()
  },
  //选择盘点位置
  methods: {

    handleChange (name) {
      this.keyword.area = name[0]
      this.keyword.col = name[1]
      this.keyword.knot = name[2]
    },

    //打开关联设备弹窗
    openEquip (user_id) {
      this.getEquipList(user_id)
      this.equipDio = true
    },

    //获取列表数据
    async getList (curr, limit) {
      let that = this

      if (that.time.length) {
        that.keyword.start_time = that.time[0]
        that.keyword.end_time = that.time[1]
      }

      let data = {
        perPage: limit ? limit : that.page,
        page: curr ? curr : that.curr,
        user_name: that.keyword.user_name,
        area: that.keyword.area,
        col: that.keyword.col,
        knot: that.keyword.knot,
        start_time: that.keyword.start_time,
        end_time: that.keyword.end_time,
        flag: that.keyword.flag
      }

      let res = await lvApi.getList(data);

      if (typeof res !== 'undefined') {
        if (res.meta.code == 200) {
          that.dataList = res.data.list
          that.total = parseInt(res.data.total)

          that.pageCount = Math.ceil(that.total / that.page)

          if (that.dataList) {
            that.dataList.forEach(function (value, index) {
              if (value.area && value.col && value.knot) {
                that.dataList[index].area = value.area + '区' + value.col + '列' + value.knot + '节'
              }
            })
          }
        } else {
          showToast(res.meta.message)
        }
      } else {
        showToast('网络异常')
      }
    },


    //导出
    async exportCsv () {
      console.log(222)
      let that = this

      if (that.time.length) {
        that.keyword.start_time = that.time[0]
        that.keyword.end_time = that.time[1]
      }

      let data = {
        perPage: that.page,
        page: that.curr,
        user_name: that.keyword.user_name,
        area: that.keyword.area,
        col: that.keyword.col,
        knot: that.keyword.knot,
        start_time: that.keyword.start_time,
        end_time: that.keyword.end_time,
        flag: that.keyword.flag
      }

      let res = await lvApi.export(data);

      if (res.meta.code = 200) {
        let downloadElement = document.createElement('a')
        let downloadUrl = config.commonAddress4 + '/' + res.data.url
        console.log(downloadUrl)
        //let href = window.URL.createObjectURL(downloadUrl)

        downloadElement.href = downloadUrl
        downloadElement.download = downloadUrl
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(downloadUrl)
      }
    },

    //首页分页
    CurrentChange (currentPage) {
      this.getList(currentPage)
    },

    //详情
    info (id) {
      this.eq_id = id
      this.getInfo(id)
      this.equipDio = true
    },

    //获取详情
    async getInfo (id, curr, limit) {
      let that = this

      let data = {
        id: id,
        perPage: limit ? limit : that.eq_page,
        page: curr ? curr : that.curr
      }

      let res = await lvApi.detail(data);

      if (typeof res !== 'undefined') {
        if (res.meta.code == 200) {
          that.detail = res.data.list
          that.eq_total = parseInt(res.data.total)
          //that.eq_curr = res.data.current_page
        } else {
          showToast(res.meta.message)
        }
      } else {
        showToast('网络异常')
      }
    },

    //详情分页
    eqCurrentChange () {
      this.getInfo(this.eq_id, this.eq_curr)
    },

    //获取位置信息
    async getPosition () {
      let that = this
      let res = await lvApi.getPosition();

      if (typeof res !== 'undefined') {
        if (res.meta.code == 200) {
          that.position = res.data
        } else {
          showToast(res.meta.message)
        }
      } else {
        showToast('网络异常')
      }
    },

    CurrentSizeChange (val) {
      this.page = val
      // console.log(`当前页: ${val}`);
      this.getUserList()

    },
  },
  watch: {
    // 监听vuex的值变化
    "$store.state.buildingID": async function (newVal, oldVal) {
      this.buildingID = newVal;
    }
  }
}
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto;
// }
.CCasualUser {
  .searchDiv {
    .el-input,
    .el-button {
      display: block;
    }
  }
  .mr10 {
    margin-right: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .btnArea {
    margin-top: 10px;
  }
  .fs25 {
    font-size: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CInventoryModule/CInventoryRecords.vue